@if (auctionData(); as auction) { @if (auction?.id) { @if (isDesktop) {
<div class="desktop-product-timer">
  <div class="timer">
    @for (unit of timeUnits(); track $index; let first = $first) { @if
    (secondsLeft() > 0) {
    <div class="time-box">
      <div class="flip-card">
        <div class="time-value">{{ unit?.value }}</div>
      </div>
    </div>
    @if (first && timeUnits().length > 1) {
    <div class="time-label">:</div>
    } } }
  </div>
</div>
}

<div class="auction-container">
  <div
    class="auction-slide"
    [class.slide-left]="slideLeft"
    [class.slide-right]="slideRight"
  >
    <div
      class="auction-wrapper"
      (touchstart)="onTouchStart($event)"
      (touchend)="onTouchEnd($event)"
    >
      <div class="product-grid">
        <div class="product-card left-card">
          @if (isActive(vm().leftItem, vm().isLeftOriginalFirst) && isDesktop) {
          <div class="arrow-first-container">
            <svg
              [class.blink-arrow]="
                isActive(vm().leftItem, vm().isLeftOriginalFirst) &&
                secondsLeft() > 0
              "
              class="arrow arrow-right"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 70"
            >
              <polygon
                points="5,20 60,20 60,5 95,35 60,65 60,50 5,50"
                fill="white"
                stroke="red"
                stroke-width="6"
                stroke-linejoin="miter"
              />
            </svg>
          </div>
          }

          <h2 class="product-name">{{ vm().leftItem.product.name }}</h2>
          <div class="image-section">
            <div class="image-container">
              <div
                [class.blink-border]="
                  isActive(vm().leftItem, vm().isLeftOriginalFirst) &&
                  secondsLeft() > 0
                "
                class="image-wrapper"
              >
                <div class="simple-image-gallery">
                  <img
                    [src]="getCurrentLeftImage()"
                    [alt]="vm().leftItem.product.name"
                    class="product-image"
                    loading="lazy"
                    [ngStyle]="getGalleryStyle()"
                  />

                  <div class="image-nav">
                    <button
                      class="nav-button prev-button"
                      (click)="prevLeftImage()"
                      aria-label="Poprzednie zdjęcie"
                    >
                      <i class="pi pi-chevron-left"></i>
                    </button>

                    <button
                      class="nav-button next-button"
                      (click)="nextLeftImage()"
                      aria-label="Następne zdjęcie"
                    >
                      <i class="pi pi-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="test">
            <div class="product-overlay">
              <span class="brand-label">
                <img
                  [src]="vm().leftItem.product.brandLogoUrl"
                  class="brand-logo"
                  [alt]="vm().leftItem.product.brandName"
                />
              </span>
              <div>
                <p class="price-label">
                  {{ vm().leftItem.data.startPrice | priceFormat
                  }}<span class="currency"> zł</span>
                </p>
                <span class="start-price-label">Cena start</span>
              </div>
            </div>
          </div>

          <div class="action-section">
            @if (vm().leftItem.data.priceDifference) {
            <div class="price-difference first">
              <span
                [class.blink-price]="
                  isActive(vm().leftItem, vm().isLeftOriginalFirst) &&
                  secondsLeft() > 0
                "
                class="current-price first"
              >
                {{ vm().leftItem.data.priceDifference | priceFormat
                }}<span class="currency"> zł</span>
              </span>
            </div>
            } @else {
            <div class="price-difference first trans">
              <span class="current-price first" style="color: transparent">
                0
              </span>
            </div>
            }
            <div class="pricing">
              <span
                [class.blink-price]="
                  isActive(vm().leftItem, vm().isLeftOriginalFirst) &&
                  secondsLeft() > 0
                "
                class="current-price first"
              >
                {{ vm().leftItem.data.currentPrice | priceFormat
                }}<span class="currency"> zł</span>
              </span>
            </div>

            @if (secondsLeft() > 0) {
            <div class="button-container first">
              @if (((vm().isLeftOriginalFirst ? firstProductActuallyStep() :
              secondProductActuallyStep()) === 0 || (vm().isLeftOriginalFirst ?
              firstProductActuallyStep() : secondProductActuallyStep()) !==
              vm().leftItem.data.level) || newFirstProduct() === '' ) {
              <button
                pButton
                label="REZERWUJ"
                [disabled]="vm().leftItem.data.level === 0 && secondsLeft() > 0"
                (click)="
                  onReserve(
                    vm().leftItem.product,
                    vm().isLeftOriginalFirst,
                    vm().leftItem.data.level
                  )
                "
                class="reserve-button"
              ></button>
              <app-info-button
                [customClass]="'auction-page'"
                [dialogContent]="
                  'Po każdej zmianie ceny masz 1 szanse na rezerwacje produktu w nowej, niższej cenie.'
                "
              />
              } @else {
              <div class="reservation-info">
                @if (!(vm().isLeftOriginalFirst ? firstProductErrorReserved() :
                secondProductErrorReserved())) {
                <i class="pi pi-check icon-circle"></i>
                <p class="m-0">Udało się! Kod jest Twój!</p>
                } @else {
                <i class="pi pi-times icon-circle"></i>
                <p class="m-0">
                  {{
                    vm().isLeftOriginalFirst
                      ? firstProductErrorMessage()
                      : secondProductErrorMessage()
                  }}
                </p>
                }
              </div>
              <app-info-button
                [customClass]="'auction-page'"
                [dialogContent]="
                  !(vm().isLeftOriginalFirst
                    ? firstProductErrorReserved()
                    : secondProductErrorReserved())
                    ? vm().isLeftOriginalFirst
                      ? 'Twoja rezerwacja była ' +
                        reservedPositionFirst() +
                        ' z ' +
                        maxStockFirst() +
                        ' dostępnych sztuk w nowej, niższej cenie'
                      : 'Twoja rezerwacja była ' +
                        reservedPositionSecond() +
                        ' z ' +
                        maxStockSecond() +
                        ' dostępnych sztuk w nowej, niższej cenie'
                    : vm().isLeftOriginalFirst
                    ? 'Wykorzystano już limit ' + maxStockFirst() + ' kodów.'
                    : 'Wykorzystano już limit ' + maxStockSecond() + ' kodów.'
                "
              />
              }
            </div>
            }
          </div>
        </div>
        @if (isTablet || isMobile) {
        <div class="mobile-action-bar">
          <div class="change-order-container">
            <button
              class="icon-btn"
              (click)="toggleOrder(); closeMenu()"
              aria-label="Zmień kolejność"
              title="Zmień kolejność"
            >
              <i class="pi pi-refresh"></i>
            </button>
          </div>
          <div class="divider"></div>
          <div class="product-timer">
            <div class="timer">
              @for (unit of timeUnits(); track $index; let first = $first) { @if
              (secondsLeft() > 0) {
              <div class="time-box">
                <div class="flip-card">
                  <div class="time-value">{{ unit?.value }}</div>
                </div>
              </div>
              @if (first && timeUnits().length > 1) {
              <div class="time-label">:</div>
              } } }
            </div>
          </div>
          <div class="divider"></div>
          <div class="share-page-container">
            <button
              class="icon-btn"
              (click)="sharePage(); closeMenu()"
              aria-label="Udostępnij"
              title="Udostępnij"
            >
              <i class="pi pi-share-alt"></i>
            </button>
          </div>
        </div>
        }
        <div class="product-card right-card">
          @if (isActive(vm().rightItem, !vm().isLeftOriginalFirst) && isDesktop)
          {
          <div class="arrow-second-container">
            <svg
              [class.blink-arrow]="
                isActive(vm().rightItem, !vm().isLeftOriginalFirst) &&
                secondsLeft() > 0
              "
              class="arrow arrow-left"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 70"
            >
              <polygon
                points="5,20 60,20 60,5 95,35 60,65 60,50 5,50"
                fill="white"
                stroke="red"
                stroke-width="6"
                stroke-linejoin="miter"
              />
            </svg>
          </div>
          }

          <div class="image-section second">
            <h2 class="product-name">{{ vm().rightItem.product.name }}</h2>

            <div class="image-container">
              <div
                [class.blink-border]="
                  isActive(vm().rightItem, !vm().isLeftOriginalFirst) &&
                  secondsLeft() > 0
                "
                class="image-wrapper"
              >
                <div class="simple-image-gallery">
                  <img
                    [src]="getCurrentRightImage()"
                    [alt]="vm().rightItem.product.name"
                    class="product-image"
                    loading="lazy"
                    [ngStyle]="getGalleryStyle()"
                  />

                  <div class="image-nav">
                    <button
                      class="nav-button prev-button"
                      (click)="prevRightImage()"
                      aria-label="Poprzednie zdjęcie"
                    >
                      <i class="pi pi-chevron-left"></i>
                    </button>
                    <button
                      class="nav-button next-button"
                      (click)="nextRightImage()"
                      aria-label="Następne zdjęcie"
                    >
                      <i class="pi pi-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="test">
            <div class="product-overlay second">
              <span class="brand-label">
                <img
                  [src]="vm().rightItem.product.brandLogoUrl"
                  class="brand-logo"
                  [alt]="vm().rightItem.product.brandName"
                />
              </span>
              <div>
                <p class="price-label">
                  {{ vm().rightItem.data.startPrice | priceFormat
                  }}<span class="currency"> zł</span>
                </p>
                <span class="start-price-label">Cena start</span>
              </div>
            </div>
          </div>

          <div class="action-section">
            @if (vm().rightItem.data.priceDifference) {
            <div class="price-difference second">
              <span
                [class.blink-price]="
                  isActive(vm().rightItem, !vm().isLeftOriginalFirst) &&
                  secondsLeft() > 0
                "
                class="current-price second"
              >
                {{ vm().rightItem.data.priceDifference | priceFormat
                }}<span class="currency"> zł</span>
              </span>
            </div>
            } @else {
            <div class="price-difference second trans">
              <span class="current-price second" style="color: transparent">
                0
              </span>
            </div>
            }
            <div class="pricing second">
              <span
                [class.blink-price]="
                  isActive(vm().rightItem, !vm().isLeftOriginalFirst) &&
                  secondsLeft() > 0
                "
                class="current-price second"
              >
                {{ vm().rightItem.data.currentPrice | priceFormat
                }}<span class="currency"> zł</span>
              </span>
            </div>

            @if (secondsLeft() > 0) {
            <div class="button-container second">
              @if ((!vm().isLeftOriginalFirst ? firstProductActuallyStep() :
              secondProductActuallyStep()) === 0 || (!vm().isLeftOriginalFirst ?
              firstProductActuallyStep() : secondProductActuallyStep()) !==
              vm().rightItem.data.level || newSecondProduct() === '' ) {
              <button
                pButton
                label="REZERWUJ"
                pRipple
                [disabled]="
                  vm().rightItem.data.level === 0 && secondsLeft() > 0
                "
                (click)="
                  onReserve(
                    vm().rightItem.product,
                    !vm().isLeftOriginalFirst,
                    vm().rightItem.data.level
                  )
                "
                class="reserve-button"
              ></button>
              <app-info-button
                [customClass]="'auction-page'"
                [dialogContent]="
                  'Po każdej zmianie ceny masz 1 szanse na rezerwacje produktu w nowej, niższej cenie.'
                "
              />
              } @else {
              <div class="reservation-info">
                @if (!(!vm().isLeftOriginalFirst ? firstProductErrorReserved() :
                secondProductErrorReserved())) {
                <i class="pi pi-check icon-circle"></i>
                <p class="m-0">Udało się! Kod jest Twój!</p>
                } @else {
                <i class="pi pi-times icon-circle"></i>
                <p class="m-0">
                  {{
                    !vm().isLeftOriginalFirst
                      ? firstProductErrorMessage()
                      : secondProductErrorMessage()
                  }}
                </p>
                }
              </div>
              <app-info-button
                [customClass]="'auction-page'"
                [dialogContent]="
                  !(!vm().isLeftOriginalFirst
                    ? firstProductErrorReserved()
                    : secondProductErrorReserved())
                    ? !vm().isLeftOriginalFirst
                      ? 'Twoja rezerwacja była ' +
                        reservedPositionFirst() +
                        ' z ' +
                        maxStockFirst() +
                        ' dostępnych sztuk w nowej, niższej cenie'
                      : 'Twoja rezerwacja była ' +
                        reservedPositionSecond() +
                        ' z ' +
                        maxStockSecond() +
                        ' dostępnych sztuk w nowej, niższej cenie'
                    : !vm().isLeftOriginalFirst
                    ? 'Wykorzystano już limit ' + maxStockFirst() + ' kodów.'
                    : 'Wykorzystano już limit ' + maxStockSecond() + ' kodów.'
                "
              />
              }
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
} }
